export default __webpack_public_path__ + "static/media/no-transactions.df29a7c1.svg";